
const ImageGalleryItem = (props)=> {
    return (
        <div className={props.index == 1 ? "active item" : "item "}>
            <a href={props.data.ModLinksLink.NavigateUrl}>
                <div className="card">
                    <img src={props.data.ModDTImage_Url} className="img-fluid mx-auto d-block" alt=''/>
                    <div className="card-body">
                        <div className="card-text" >{props.data.Title}
                        <span className="floatLeft fa fa-chevron-left" aria-hidden="true"></span></div>
                    </div>
                </div>
            </a>
        </div>
    )
}
export default ImageGalleryItem; 